/* eslint-disable import/no-unresolved */
import React, { memo } from 'react';
import PdfIcon from 'images/pdf_icon.png';
import Mp3Icon from 'images/mp3_file.png';
import ImageMC from '../../../components/ImageMC';
import IconMC from '../../../components/IconMC';
import VideoMC from '../../../components/VideoMC';
import { useTraceUpdate } from '../../../hooks/shared/useDebugRenders';

/**
 * AttachedFastAnswerMC - Componente para mostrar una respuesta rápida adjunta a un mensaje.
 */
const AttachedFastAnswerMC = memo(({ fastAnswer, onRemoveFastAnswer }) => {
  // Debug: rastreo de renders y cambios de props
  useTraceUpdate('AttachedFastAnswerMC', {
    fastAnswerId: fastAnswer?.attributes?.id,
    fileType: fastAnswer?.attributes?.file_type,
    imageUrl: fastAnswer?.attributes?.image_url,
    fileUrl: fastAnswer?.attributes?.file_url,
    onRemoveFastAnswer
  });

  if (!fastAnswer) return null;

  const { attributes } = fastAnswer;
  let url = attributes.image_url;
  const isFile = attributes.file_type === 'file';
  const isVideo = attributes.file_type === 'video';
  const isAudio = attributes.file_type === 'audio';
  const wh = isAudio || isFile ? 'tw-w-10' : 'tw-h-20 tw-w-20';

  if (isFile) url = PdfIcon;
  if (isAudio) url = Mp3Icon;

  // No mostrar nada si url no está definido
  if (!url) return null;

  return (
    <div className="tw-relative tw-m-2">
      <div className="tw-absolute tw-top-[-8px] tw-right-[-8px] tw-z-10">
        <IconMC
          name="close-circle-fill"
          size="xl"
          className="tw-text-gray-400 hover:tw-text-red-500 tw-bg-white tw-rounded-full"
          onClick={onRemoveFastAnswer}
        />
      </div>
      {isVideo ? (
        <VideoMC
          key={url}
          data={{ contentMediaUrl: url }}
          className="tw-h-20 tw-w-auto tw-rounded-lg"
        />
      ) : (
        <ImageMC
          key={url}
          data={{ contentMediaUrl: url }}
          alt="Fast Answer"
          className={`${wh} tw-object-cover tw-rounded-lg tw-border tw-border-gray-200`}
        />
      )}
    </div>
  );
});

AttachedFastAnswerMC.displayName = 'AttachedFastAnswerMC';

export default AttachedFastAnswerMC;
